module.exports = __webpack_public_path__ + "static/media/promotion5.e94993a9.jpeg";